import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive( {
	selector: '[appHighlightText]'
} )
export class HighlightTextDirective implements OnChanges {

	@Input() search: string;

	@Input() text: string;

	@Input() classToApply: string;

	@Input() revertMatch: boolean;

	@Input() disableHighlighting: boolean;

	@Input() fireChange: boolean;

	constructor( private el: ElementRef, private renderer: Renderer2 ) { }

	private setRendererProperty() {
		this.renderer.setProperty( this.el.nativeElement, 'innerHTML', this.text );
	}


	ngOnChanges( changes: SimpleChanges ): void {

		// let pass if only either text or search is null (needed for whitespace comparison)
		if ( this.disableHighlighting || (!this.search && !this.text) ) {
			this.renderer.setProperty( this.el.nativeElement, 'innerHTML', this.text );
			return;
		}

		this.renderer.setProperty(
			this.el.nativeElement,
			'innerHTML',
			this.getFormattedText()
		);
	}

	getFormattedText() {
		// @ts-ignore
		if ( this.revertMatch === true ) {
			let diff = '';
			// set to empty string if null (needed for whitespace comparison)
			this.text = !this.text || this.text === undefined ? '' : this.text;
			this.search = !this.search || this.search === undefined ? '' : this.search;

			const iterateOverLongerText = this.text.length >= this.search.length ? this.text : this.search;
			const compareText = this.text.length < this.search.length ? this.text : this.search;

			iterateOverLongerText.split( '' ).forEach( ( char, i ) => {
				const compareTextChar = compareText.charAt( i );

				// chars match
				if ( char === compareTextChar ) {
					diff += this.text.charAt( i );

					// chars do not match
				} else if ( compareTextChar && compareTextChar !== ' ' ) { // char without whitespace
					diff += `<span class="${ this.classToApply ? `text ${ this.classToApply}` : `text`}">${ this.text.charAt( i ) }</span>`;
				} else { // char with whitespace
					this.text.length >= this.search.length
					? diff += `<span class="${ this.classToApply ? `text bg ${ this.classToApply}` : `text bg`}">${ this.text.charAt( i ) }</span>` // on
						// search
					: diff += `<span class="${ this.classToApply ? `bg ${ this.classToApply}` : `bg`}">&nbsp;</span>`; // on text
				}
			} );

			return diff;
		} else {
			const re = new RegExp( `(${ this.search })`, 'g' );
			return this.text.replace( re, `<span class="text ${ this.classToApply }">$1</span>` );
		}
	}
}
